import React from "react";

const ProfileInfobar = ({ userData }) => (
  <div className="white-bg mt-10px profile-bar">
    <label className="beta-user">BETA USER</label>
    <div className="d-flex align-items-center">
      <div className="img" />
      <div>
        <p>
          {userData.firstName} {userData.lastName}
        </p>
        <label className="small-label">{userData.email}</label>
        <br />
        <label className="small-label">{userData.mobileNumber}</label>
      </div>
    </div>
    <div className="points">
      <p>
        <span className="bold">You Have</span>
        <span className="bold">{userData.points} eCoins</span>
      </p>
    </div>
  </div>
);

export default ProfileInfobar;
